export default "__VITE_ASSET__lub2GRnw__"